import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

import { pollCountOfUnread } from '_store/chat/slice';
import { getCredentials } from '_store/credentials/slice';
import { resetData as resetFileTypesData } from '_store/fileTypes/slice';
import { resetData as resetFilesData, resetFetchCounter as resetFilesFetchCounter } from '_store/files/slice';
import { selectActiveOrderId } from '_store/order/selector';
import { getOrder, refreshActiveOrderId, restoreActiveOrderId } from '_store/order/slice';
import { getOrders } from '_store/orders/slice';
import {
  resetData as resetStatementsData,
  resetFetchCounter as resetStatementsFetchCounter,
} from '_store/statements/slice';
import { selectCustomerId } from '_store/user/selector';

import AddPaymentMethodModal from 'components/composed/modals/AddPaymentMethodModal';
import AddTransactionModal from 'components/composed/modals/AddTransactionModal';
import AppointmentSchedulingModal from 'components/composed/modals/AppointmentSchedulingModal';
import DeleteBankAccountModal from 'components/composed/modals/DeleteBankAccountModal';
import DeleteStatementModal from 'components/composed/modals/DeleteStatementModal';
import DeleteTransactionModal from 'components/composed/modals/DeleteTransactionModal';
import SendTaskResponseModal from 'components/composed/modals/SendTaskResponseModal';
import UpdateTransactionModal from 'components/composed/modals/UpdateTransactionModal';
import UploadDocumentModal from 'components/composed/modals/UploadDocumentModal';
import XeroAuthConfirmationModal from 'components/composed/modals/XeroAuthConfirmationModal';

const StyledContainer = styled.div``;

const PrivateLayout = () => {
  const { pathname } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const customerId = useSelector(selectCustomerId);
  const orderId = useSelector(selectActiveOrderId);

  useEffect(() => {
    if (customerId && orderId) {
      const orderIdParam = searchParams.get('orderId');

      if (pathname && (!orderIdParam || orderId !== orderIdParam)) {
        setSearchParams({ orderId });
      }

      dispatch(getOrder({ customerId, orderId }));
    }
  }, [customerId, orderId, pathname]);

  useEffect(() => {
    if (customerId) {
      dispatch(getCredentials({ customerId }));
      dispatch(getOrders({ customerId }));
      dispatch(pollCountOfUnread({ customerId }));
    }
  }, [customerId]);

  useEffect(() => {
    if (pathname) {
      const orderIdParam = searchParams.get('orderId');

      if (orderIdParam) {
        dispatch(refreshActiveOrderId(orderIdParam));
      } else {
        dispatch(restoreActiveOrderId());
      }

      dispatch(resetStatementsFetchCounter());
      dispatch(resetStatementsData());
      dispatch(resetFilesFetchCounter());
      dispatch(resetFilesData());
      dispatch(resetFileTypesData());
    }
  }, [pathname]);

  return (
    <StyledContainer>
      <Outlet />
      <AppointmentSchedulingModal />
      <AddPaymentMethodModal />
      <AddTransactionModal />
      <UpdateTransactionModal />
      <DeleteTransactionModal />
      <UploadDocumentModal />
      <XeroAuthConfirmationModal />
      <DeleteStatementModal />
      <SendTaskResponseModal />
      <DeleteBankAccountModal />
    </StyledContainer>
  );
};

export default PrivateLayout;
